<template>
  <div>
    <el-button type="text" @click="look()">查看详情</el-button>
    <el-dialog title="详情信息" :visible.sync="dialogVisible" width="70%">
      <div>
        <div style="display:flex;justify-content: space-between;">
          <div style="display:flex;">
            <div>产品名称</div>
            <el-input type="text" v-model="data.productName"></el-input>
          </div>
        </div>
        <div style="display:flex;justify-content: space-between;">
          <div style="display:flex;">
            <div>
              logo:
            </div>
            <div>
              <el-upload
                class="avatar-uploader"
                action="/api/file/upload"
                :show-file-list="false"
                :on-success="handleAvatarSuccessLogo"
                name="uploadFile"
              >
                <img
                  v-if="data.productLogo"
                  :src="data.productLogo"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div style="display:flex;">
            <div>
              二维码:
            </div>
            <div>
              <el-upload
                class="avatar-uploader"
                action="/api/file/upload"
                :show-file-list="false"
                :on-success="handleAvatarSuccessCode"
                name="uploadFile"
              >
                <img
                  v-if="data.productCode"
                  :src="data.productCode"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div style="display:flex;">
            <div>产品链接：</div>
            <el-input
              style=" width: 500px"
              v-model="data.productUrl"
            ></el-input>
          </div>
        </div>
        <div style="display:flex;">
          <div style="display:flex;">
            <div>
              产品介绍：
            </div>
            <div>
              <ckeditor
                style="width:50%"
                :editor="editor"
                v-model="data.productIntroduction"
                :config="editorConfig"
              ></ckeditor>
            </div>
          </div>
        </div>
        <div style="display:flex;">
          <div>
            配图:
          </div>
          <div>
            <el-upload
              class="avatar-uploader"
              action="/api/file/upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccessImg"
              name="uploadFile"
            >
              <img
                v-if="data.productImg"
                :src="data.productImg"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>
      <el-button type="primary" @click="updata()">提交</el-button>
    </el-dialog>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        removePlugins: ["MediaEmbed"], //除去视频按钮
        language: "zh-cn", //中文包
        toolbar: [
          "heading", //段落
          "|", //分隔
          "bold", //加粗
          "italic", //倾斜
          "link", //超链接
          "bulletedList", //项目列表
          "numberedList", //编号列表
          "blockQuote", //块引用
          "undo", //撤销
          "redo" //重做
        ] //工具栏显示
      },
      dialogVisible: false,
      peitu: require("@/assets/logo.png"),
      data: {
        productImg: "",
        productCode: "",
        productLogo: "",
        productName: "",
        productUrl: "",
        productIntroduction: ""
      }
    };
  },
  props: {
    postId: {
      default: () => {}
    }
  },
  methods: {
    updata() {
      this.$emit("dataReturn", this.data);
      this.dialogVisible = false;
    },
    look() {
      this.dialogVisible = true;
      if (this.postId) {
        this.data = this.postId;
      }
    },
    handleAvatarSuccessImg(res) {
      this.data.productImg = res.data.fileurl;
    },
    handleAvatarSuccessCode(res) {
      this.data.productCode = res.data.fileurl;
    },
    handleAvatarSuccessLogo(res) {
      this.data.productLogo = res.data.fileurl;
    }
    // handleClose(done) {
    //   this.$confirm("确认关闭？")
    //     .then(_ => {
    //       done();
    //     })
    //     .catch(_ => {});
    // }
  }
};
</script>
